import ActionsTypes from '../../constants/ActionsTypes'

const table = {
	getAllSavedTableColumnsDisplay: () => ({
		type: ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY,
	}),
	getAllSavedTableColumnsDisplaySuccess: (data) => ({
		type: ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS,
		payload: {
			data,
		},
	}),
	getAllSavedTableColumnsDisplayFailure: (error) => ({
		type: ActionsTypes.GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE,
		payload: {
			error,
		},
	}),
	setSavedTableColumnsDisplay: (column) => ({
		type: ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY,
		payload: {
			column,
		},
	}),
	setSavedTableColumnsDisplaySuccess: (data) => ({
		type: ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY_SUCCESS,
		payload: {
			data,
		},
	}),
	setSavedTableColumnsDisplayFailure: (error) => ({
		type: ActionsTypes.SET_SAVED_TABLE_COLUMNS_DISPLAY_FAILURE,
		payload: {
			error,
		},
	}),
	setSavedPaggingConfig: (data) => ({
		type: ActionsTypes.SET_SAVED_PAGGING_CONFIG,
		payload: {
			data,
		},
	}),
	resetPaggingConfig: () => ({
		type: ActionsTypes.RESET_PAGGING_CONFIG,
		payload: {},
	}),
	setIsFromRedirect: () => ({
		type: ActionsTypes.SET_IS_FROM_REDIRECT,
		payload: {},
	}),
}

export default table
